import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  inject,
} from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MenuService, NavItem } from "@core/services/utils/menu.service";
import { TranslatePipe } from "@ngx-translate/core";
import { BEBasicService } from "@services/be-basic.service";
import { ButtonIconComponent } from "@ui/controls/button-icon/button-icon.component";
import { IconDisplayComponent } from "@ui/ui-helpers/display-formats/icon-display/icon-display.component";
import { PillComponent } from "@ui/ui-helpers/display-formats/pill/pill.component";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-lc-menu",
  templateUrl: "./lc-menu.component.html",
  styleUrl: "./lc-menu.component.scss",
  imports: [
    RouterLinkActive,
    RouterLink,
    IconDisplayComponent,
    TranslatePipe,
    ButtonIconComponent,
    PillComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LcMenuComponent implements OnInit, OnDestroy {
  private readonly menuService = inject(MenuService);
  private readonly apiServices = inject(BEBasicService);
  private readonly cdr = inject(ChangeDetectorRef);

  protected navItems: NavItem[] = [];
  protected isCollapsed = false;
  protected isMenuLoaded = false;
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.checkUserLoginAndLoadMenu();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkUserLoginAndLoadMenu(): void {
    this.apiServices
      .isUserLoggedIn()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.loadMenu();
        }
      });
  }

  private loadMenu(): void {
    this.menuService
      .getMenu()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: NavItem[]) => {
        this.navItems = data;
        this.isMenuLoaded = true;
        this.cdr.markForCheck();
      });
  }

  toggleMenu(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  getDataTestId(displayName: string): string {
    const dataTestId = displayName.toLowerCase().replace(".", "-");
    return dataTestId;
  }

  getNavItemUrl(
    navItem: NavItem
  ): { params: string[]; queryParams?: Record<string, string> } | null {
    if (navItem.route) {
      const [path, query] = navItem.route.split("?");
      const params = path.split("/").filter((segment: string) => segment);

      const queryParams = query
        ? query.split("&").reduce((acc: Record<string, string>, param) => {
            const [key, value] = param.split("=");
            acc[key] = value;
            return acc;
          }, {})
        : undefined;

      return { params, queryParams };
    }
    return null;
  }
}
